import { create } from 'zustand';

const useModalStore = create((set) => ({
    isOrgSelectModalOpen: false,
    openOrgSelectModal: () => set({ isOrgSelectModalOpen: true }),
    closeOrgSelectModal: () => set({ isOrgSelectModalOpen: false }),
}));


export default useModalStore;